import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5c1b7d36")

_pushScopeId("data-v-5c1b7d36")
const _hoisted_1 = { class: "\n      bg-white\n      flex flex-col\n      text-12px\n      xxl:text-14px\n      overflow-hidden\n      h-screen\n      relative\n      w-full\n      balance-list\n    " }
const _hoisted_2 = { class: "flex flex-row items-center gap-4 flex-no-wrap relative" }
const _hoisted_3 = { class: "\n            font-semibold\n            text-20px\n            whitespace-no-wrap\n            text-black-lp-200\n            capitalize\n          " }
const _hoisted_4 = {
  key: 2,
  class: "overflow-auto"
}
const _hoisted_5 = { class: "py-4 flex-row flex justify-between" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "\n            font-semibold\n            text-20px\n            whitespace-no-wrap\n            text-gray-lp-300\n            capitalize\n          " }, " Detail Transaksi ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Header = _resolveComponent("Header")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_DownloadRequest = _resolveComponent("DownloadRequest")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$route?.meta.name), 1),
            _createVNode(_component_SelectSearch, {
              onFocus: _ctx.fetchClientPartner,
              onFilter: _ctx.fetchClientPartner,
              isLoading: _ctx.isLoadingClientPartner,
              options: _ctx.clientPartnerData,
              keyName: "name",
              keyValue: "code",
              placeholder: "Pilih Nama POS/Nama Klien",
              modelValue: _ctx.clientPartner,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.clientPartner = $event)),
              onChange: _ctx.onChangeClient,
              customWidth: "w-200px"
            }, null, 8, ["onFocus", "onFilter", "isLoading", "options", "modelValue", "onChange"]),
            _createVNode(_component_CustomDropdown, {
              isExpand: _ctx.isOpenSelect,
              "onUpdate:isExpand": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpenSelect = $event)),
              options: _ctx.options,
              onSelect: _ctx.onSelect,
              placeholder: "Tipe Transaksi",
              class: `select-status ${_ctx.isOpenSelect ? 'w-56' : ''}`,
              isCustomWidth: "",
              isCustomMaxHeight: "",
              selectedItem: _ctx.transactionType
            }, null, 8, ["isExpand", "options", "onSelect", "class", "selectedItem"]),
            _createVNode(_component_time_range_picker, {
              onSelect: _ctx.setPeriode,
              default: "30 hari terakhir",
              showOptions: "custom, hari ini, 7 hari terakhir, 30 hari terakhir",
              minDate: _ctx.minDate,
              maxDate: _ctx.maxRangeDatePicker,
              onDayClick: _ctx.setDay,
              class: "mr-4",
              style: {"margin-right":"0"}
            }, null, 8, ["onSelect", "minDate", "maxDate", "onDayClick"]),
            _createVNode(_component_lp_button, {
              title: "Cari",
              textColor: "white",
              textColorHover: "white",
              onClick: _ctx.goFilter,
              disabled: _ctx.filterDisable
            }, null, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      }),
      (
        !_ctx.isError &&
          !_ctx.isLoading &&
          _ctx.balanceTransactionList.length === 0 &&
          _ctx.isFirstRequest
      )
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            data: "Transaksi Saldo",
            customHeaderMessage: "Belum Ada Data Transaksi",
            customMessage: "Anda bisa mencari dengan kata kunci atau filter transaksi\n"
          }))
        : (!_ctx.isError && !_ctx.isLoading && _ctx.balanceTransactionList.length === 0)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 1,
              errorType: _ctx.errorCause || 'notfound',
              keywordCase: true,
              onTryAgain: _ctx.fetchBalanceTransactionList
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_lp_button, {
                  title: "Download",
                  textColor: "red-lp-100",
                  iconLeft: "document-download-outline",
                  outline: "",
                  onClick: _ctx.downloadBalanceMutation
                }, null, 8, ["onClick"])
              ]),
              _createVNode(_component_TableV2, {
                columns: _ctx.columns,
                data: _ctx.balanceTransactionList,
                loading: _ctx.isLoading,
                pagination: _ctx.pagination,
                "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.pagination = $event)),
                totalColumnFreeze: 0,
                isRightFreeze: "",
                errorCause: _ctx.errorCause,
                paginationStyle: "v3",
                pinnedSubstractHeight: "295px",
                onRequest: _ctx.fetchBalanceTransactionList,
                paginationWidth: "w-3/4"
              }, null, 8, ["columns", "data", "loading", "pagination", "errorCause", "onRequest"])
            ]))
    ]),
    _withDirectives(_createVNode(_component_DownloadRequest, null, null, 512), [
      [_vShow, _ctx.balanceTransactionList.length !== 0]
    ])
  ], 64))
})